export default "__VITE_ASSET__DwnKpbIe__"